import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { union } from "../../../shared/src/codecs/types/union";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject } from "../EmptyObject";

export const AdHocTaskReassignInput = required({
    id: uuid(),
    assigned_to: union([nullCodec(), uuid()]),
});
export type TAdHocTaskReassignInputCodec = typeof AdHocTaskReassignInput;

export const AdHocTaskReassignFormIO: TFormIOCodec<TAdHocTaskReassignInputCodec, TRequiredCodec<{}>> = formIO(
    AdHocTaskReassignInput,
    EmptyObject,
);
export type TAdHocTaskReassignFormIOCodec = typeof AdHocTaskReassignFormIO;
export type TAdHocTaskReassignFormIO = TTypeOfCodec<typeof AdHocTaskReassignFormIO>;
